var map = {
	".": "Mug6",
	"./": "Mug6",
	"./01_get_currentTrack": "0uty",
	"./01_get_currentTrack.json": "0uty",
	"./02_post_close_currentTrack": "6Kq+",
	"./02_post_close_currentTrack.json": "6Kq+",
	"./03_post_tpsl_currentTrack": "Aoay",
	"./03_post_tpsl_currentTrack.json": "Aoay",
	"./05_swap_trader_detail": "t/o3",
	"./05_swap_trader_detail.json": "t/o3",
	"./06_swap_trader_profit_summary": "C/st",
	"./06_swap_trader_profit_summary.json": "C/st",
	"./07_swap_trader_profit_detail": "F3OC",
	"./07_swap_trader_profit_detail.json": "F3OC",
	"./08_swap_trader_set_commission": "Dog/",
	"./08_swap_trader_set_commission.json": "Dog/",
	"./09_swap_trader_trading_pair": "Sp22",
	"./09_swap_trader_trading_pair.json": "Sp22",
	"./index": "Mug6",
	"./index.js": "Mug6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w5HM";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/copyTrade/api/pFuturesTrader ^.*$
// module id = w5HM
// module chunks = 3